import dayjs from 'dayjs';
import { IMailType } from 'app/shared/model/mail-type.model';

export interface IMail {
  id?: number;
  email?: string;
  password?: string;
  createdDate?: dayjs.Dayjs | null;
  mailType?: IMailType | null;
}

export const defaultValue: Readonly<IMail> = {};
